import { ActionButtonConfig } from 'models/ActionButtonConfig';
import React from 'react';
import checkIsMobile from 'utils/CheckIsMobile';
import 'assets/scss/portabilidad-container.scss';
import { ControlLayout } from 'components/ControlLayout';

type MultiFromProps = {
	currentStep: number;
	controlConfig: ActionButtonConfig[];
	view: JSX.Element;
	isError: boolean;
};

export const SingleFormContainer = ({
	controlConfig,
	view,
	currentStep,
	isError,
}: MultiFromProps) => {
	const configAction: ActionButtonConfig[] = controlConfig;

	const classContainer = checkIsMobile()
	? 'portabilidad-container'
	: 'portabilidad-container card-box';

	return (
		<div className={classContainer}>

			{view}

			<ControlLayout
				inputError={isError}
				disableBackButton={configAction[currentStep].buttonBackName === ''}
				handleBackClick={configAction[currentStep].buttonBackClick}
				handleNextClick={configAction[currentStep].buttonNextClick}
				buttonBackName={configAction[currentStep].buttonBackName}
				buttonNextName={configAction[currentStep].buttonNextName}
			/>
		</div>
	);
};
